import { render, staticRenderFns } from "./SectorSingleView.vue?vue&type=template&id=68a957be&scoped=true"
import script from "./SectorSingleView.vue?vue&type=script&lang=js"
export * from "./SectorSingleView.vue?vue&type=script&lang=js"
import style0 from "./SectorSingleView.vue?vue&type=style&index=0&id=68a957be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a957be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a957be')) {
      api.createRecord('68a957be', component.options)
    } else {
      api.reload('68a957be', component.options)
    }
    module.hot.accept("./SectorSingleView.vue?vue&type=template&id=68a957be&scoped=true", function () {
      api.rerender('68a957be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/SectorSingleView.vue"
export default component.exports